module.exports = "/lucky-balls/img/regular_game/check_infoBar/check_000.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/regular_game/check_infoBar/check_000.png
// module id = 1124
// module chunks = 0